var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.869,4H5.352A1.352,1.352,0,0,0,4,5.352V18.869A1.352,1.352,0,0,0,5.352,20.22H18.869a1.352,1.352,0,0,0,1.352-1.352V5.352A1.352,1.352,0,0,0,18.869,4Zm0,1.352v2.7H5.352v-2.7ZM5.352,18.869V9.407H18.869v9.462Z",
    transform: "translate(-1.297 -1.29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.76,15.723l1.906,1.913L10.76,19.548l.953.953,2.866-2.866L11.713,14.77Z",
    transform: "translate(-3.488 -4.788)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmd);
export default __webpack_public_path__ + "static/media/cmd.8410f21cb04759d1a6204893ab1b5b0b.svg";
export { ForwardRef as ReactComponent };